import { ReactNode } from "react";

interface ICreateArea {
    title: string,
    children: ReactNode
    isRequired?: boolean
    isStart?: boolean
}

const CreateArea = ({ title, children, isRequired, isStart }: ICreateArea) => {

    return (
        <div className={`flex ${isStart ? 'items-start' : 'items-center'} tablet:flex-col tablet:items-start`}>
            <p className='w-[123px] text-lg shrink-0'>{title} {isRequired && <span className='text-red'>*</span>}</p>
            {children}
        </div>
    )
}

export default CreateArea